<div class="modal-header bg-soft-info p-3">
	<h5 *ngIf="!timelineItem.id" class="card-title" style="margin-bottom: 0;" i18n="@@">New Note</h5>
	<h5 *ngIf="timelineItem.id" class="card-title" style="margin-bottom: 0;" i18n="@@">Activity - {{titleName}}</h5>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
		(click)="dismiss()">
	</button>
</div>

<div class="card-header" style="padding-top: 10px; ">
	<ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
		class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0center justify-content-center"
		role="tablist">
		<li [ngbNavItem]="1" class="nav-item">
			<a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
				<i class="fas fa-home"></i>
				<div i18n="@@">Description</div>
			</a>
			<ng-template ngbNavContent>
				<div class="row d-flex">
					<div class="mb-3">
						<label for="jobtitle-field" class="form-label">Title:</label>
						<input [disabled]="disableModel" required #title="ngModel"
							[ngClass]="{ 'is-invalid': (title.invalid && ((title.dirty || title.touched) || submitted == true))}"
							class="form-control" type="text" placeholder="Enter Note Title" i18n-placeholder="@@"
							[(ngModel)]="timelineItem.name" />
						<div *ngIf="(title.invalid && ((title.dirty || title.touched) || submitted == true))"
							class='invalidInputTextMessage'>
							<div *ngIf="title.errors?.['required']">
								<div i18n="@@">Note Title Required</div>
							</div>
						</div>
					</div>


					<div *ngIf="timelineItem.type == enumTimeLineType.Note"
						class="mb-3 d-lg-flex justify-content-lg-between">
						<div class="col-12 col-lg-4 justify-content-between d-flex row">
							<label for="jobtitle-field" class="form-label">Time Worked:</label>
							<div class="col-6">
								<input [disabled]="disableModel" required #workTimeHours="ngModel" class="form-control"
									type="text" placeholder="0" i18n-placeholder="@@" mask="000"
									[(ngModel)]="hoursSpent" />
								<div style=' margin-top:  .25rem; font-size: .875em; color:var(--vz-modal-color) ;'>
									<div class="text-muted" i18n="@@">
										Hours
									</div>
								</div>
							</div>
							<div class="col-6">
								<input [disabled]="disableModel" required #workTimeMin="ngModel" class="form-control"
									type="text" placeholder="0" i18n-placeholder="@@" mask="000"
									[(ngModel)]="minSpent" />
								<div style=' margin-top:  .25rem; font-size: .875em; color:var(--vz-modal-color);'>
									<div class="text-muted" i18n="@@">
										Minutes
									</div>
								</div>
							</div>
						</div>
						<div *ngIf="ownerEntityType != undefined" class="mb-3 col-12 col-lg-8">
							<div *ngIf="ownerEntityType == enumOwnerEntityType.Client">
								<label for="jobtitle-field" class="form-label">Note for Client:</label>
								<div class="form-control" style="padding: 0%; "
									[ngClass]="{'is-invalid': otherModel.id === undefined &&  submitted == true  }">
									<app-client-list-dropdown [disabled]="disableModel" [(referenceModel)]="otherModel"
										(referenceModel)="clientChosen(otherModel)">
									</app-client-list-dropdown>
								</div>
								<div *ngIf=" otherModel.id === undefined && submitted == true"
									class='invalidInputTextMessage'>
									<div i18n="@@Modal_Requisition_Error_ClientRequired">
										Client Selection Required
									</div>
								</div>
							</div>
						</div>

					</div>

				</div>
				<label for="jobtitle-field" class="form-label">Description:</label>
				<textarea [disabled]="disableModel" [(ngModel)]="timelineItem.description" class="form-control mb-4"
					style="height: 24vh; max-height: 40vh; overflow-y: scroll;" placeholder="Enter note contents"
					i18n-placeholder="@@"></textarea>

			</ng-template>
		</li>
		<li [ngbNavItem]="2" class="nav-item">
			<a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
				<i class="fas fa-home"></i>
				<div i18n="@@">Attachments</div>
			</a>
			<ng-template ngbNavContent>
				<span *ngIf="timelineItem.id != undefined">
					<app-file-management [entityId]="timelineItem.id" [entityTypeId]="entityTypeId"
						[entityName]="titleName"></app-file-management>
				</span>
				<span *ngIf="timelineItem.id == undefined">
					<app-file-management [filesIdsToAdd]="timelineItem.fileUpload.fileIdsToAdd"
						(filesIdsToAddChanged)="onNewModalEntityFileIdsAdded(timelineItem,$event)"
						[entityName]="titleName"
						[entityFiles]="timelineItem.fileUpload.entityFiles"></app-file-management>
				</span>
			</ng-template>
		</li>
	</ul>

</div>
<div class="card-body p-4 ">
	<div class="tab-model">
		<div class="invisible-scrollbar" style="min-height: 502px;">
			<div [ngbNavOutlet]="customNav"></div>
		</div>
		<div *ngIf="!disableModel" class="hstack justify-content-end gap-2">
			<button [disabled]="disableEditing" type="submit" class="btn btn-success d-flex " (click)="onSave()">
				<span *ngIf="!timelineItem.id" i18n="@@"> Create </span>
				<span *ngIf="timelineItem.id" i18n="@@"> Update </span>
			</button>
		</div>
	</div>
</div>